<template>
  <b-col cols="12" sm="12">
    <b-card class="mx-auto layered box" tile>
      <b-form @submit.stop.prevent="actualizarRegistrarConfiguracion">
        <div class="row mb-2">
          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">{{ $t("vConfiguraciones.ip") }}:</h5>
                  <b-form-group>
                    <b-form-input v-model="configuraciones.ip" type="text" :placeholder="$t('vConfiguraciones.ejemplo') + '187.157.140.101'
                      " id="ip" required :state="ipState" style="color: black; background-color: white"
                      aria-describedby="input-live-help-ip input-live-feedback-ip" autocomplete="off">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback-ip" class="alineacion-text-inicio">
                      {{ $t("vConfiguraciones.msgIp") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>



          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">{{ $t("vConfiguraciones.msgRadio") }}:</h5>
                  <b-form-group class="mt-2 mb-3">
                    <b-form-input v-model="configuraciones.radio" type="number" id="ip2" min="50" required
                      style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">
                    {{ $t("vConfiguraciones.puertoTK108") }}:
                  </h5>
                  <b-form-group>
                    <b-form-input v-model="configuraciones.puertotk108"
                      :placeholder="$t('vConfiguraciones.ejemplo') + '9005'" id="puertotk108" required
                      :state="puertotk108State" style="color: black; background-color: white"
                      aria-describedby="input-live-help-puerto input-live-feedback-puerto" autocomplete="off" disabled>
                    </b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback-puerto" class="alineacion-text-inicio">
                      {{ $t("vConfiguraciones.msgPuerto") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">
                    {{ $t("vConfiguraciones.puertoTKSTART") }}:
                  </h5>
                  <b-form-group>
                    <b-form-input v-model="configuraciones.puertotkstar"
                      :placeholder="$t('vConfiguraciones.ejemplo') + '9002'" id="puertotkstar" required
                      :state="puertotkstarState" style="color: black; background-color: white"
                      aria-describedby="input-live-help-puerto input-live-feedback-puerto1" autocomplete="off" disabled>
                    </b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback-puerto1" class="alineacion-text-inicio">
                      {{ $t("vConfiguraciones.msgPuerto") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">{{ $t("vConfiguraciones.apn") }}:</h5>
                  <b-form-group class="mt-2 mb-3">
                    <b-form-input v-model="configuraciones.apn" :placeholder="$t('vConfiguraciones.ejemplo') + 'internet.itelcel.com'
                      " type="text" id="ip3" required style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">{{ $t("vConfiguraciones.intervaloDispositivo") }}:</h5>
                  <b-form-group label-for="move" style="color: black" class="alineacion-text-inicio">
                    <div class="row">
                      <b-col cols="6" sm="8" class="d-flex justify-content-start align-items-center">
                        <span>{{ $t("vConfiguraciones.segundos") }}:</span>
                      </b-col>
                      <b-col cols="6" sm="4">
                        <b-form-input type="number" min="1" max="10" required
                          style="color: black; background-color: white"
                          v-model="configuraciones.intervaloTiempoDispositivo">
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">Seleccione país:</h5>
                  <div class="text-left alineacion-text-inicio">
                    <multiselect id="pais" v-model="paisSeleccionado" :options="countriesMap" :multiple="false"
                      track-by="value" label="text" :selectLabel="$t('vHistorico.presioneAgregar')"
                      emptyLabel="No se encontraron elementos" :selectedLabel="$t('vHistorico.seleccionado')"
                      :deselectLabel="$t('vHistorico.presioneEliminar')"
                      :placeholder="$t('vHistorico.mssgSelectCodigoPais')">
                      <span slot="noResult">
                        {{ $t("vHistorico.msgBusquedaFallida") }}
                      </span>
                    </multiselect>
                  </div>

                </b-col>
              </b-card-text>
            </b-card>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="4">
            <b-card class="justify-content-center layered box tamanioFijo" bg-variant="light" text-variant="black"
              align="center" header-bg-variant="dark">
              <b-card-text>
                <b-col cols="12" sm="12">
                  <h5 class="mb-2 alineacion-text-inicio">{{ $t("vConfiguraciones.puertoBack") }}:</h5>
                  <b-form-group label-for="move" style="color: black" class="alineacion-text-inicio">
                    <div class="row">
                      <b-col cols="12" sm="12">
                        <b-form-input type="number" required :placeholder="$t('vConfiguraciones.ejemplo') + '3000'"
                          style="color: black; background-color: white" v-model="configuraciones.intervaloTiempoAlerta">
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-form-group>
                </b-col>
              </b-card-text>
            </b-card>
          </b-col>

        </div>
        <div class="row">
          <div class="col-sm-12 flex-md">
            <b-btn variant="info" type="submit" class="w-100 ancho-boton" style="color: white" id="guardarMarcador"
              :disabled="validaciones()">
              {{ $t('Gral.guardar') }}
            </b-btn>
          </div>
        </div>
      </b-form>
    </b-card>
  </b-col>
</template>

<script>
import ConfiguracionesDataService from "../../../services/ConfiguracionesDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto"
import { verificarAcceso } from '../../../utils/Session';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import countries from "../../../utils/countries.json"

export default {
  name: "configuraciones_generales",
  components: { Multiselect },
  data() {
    return {
      paisSeleccionado: null,
      configuraciones: {
        id: "",
        ip: "",
        puertotk108: "",
        puertotkstar: "",
        apn: "",
        telArduino: "",
        radio: 50,
        intervaloTiempoAlerta: null,
        intervaloTiempoDispositivo: null,
        iso: "",
        paisNombre: "",
        dialCode: "",
        puertoBack: ""
      },
      configuracionesAct: {
        id: 0,
        ip: "",
        puertotk108: "",
        puertotkstar: "",
        apn: "",
        telArduino: "",
        radio: 50,
        intervaloTiempoAlerta: null,
        intervaloTiempoDispositivo: null,
        iso: "",
        paisNombre: "",
        dialCode: "",
        puertoBack: ""
      },
      tipoTiempo: "segundos",
      actualizaPuerto: false,
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      accion: "",
      key: "",
    };
  },
  beforeCreate() {
    verificarAcceso();

    if (
      !sessionStorage.getItem("rol") ||
      sessionStorage.idRol === process.env.VUE_APP_ID_USUARIO_FINAL ||
      sessionStorage.idRol === process.env.VUE_APP_ID_ADMINISTRADOR
    ) {
      this.$router.push({
        path: "/monitoreo",
      });
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: this.$t("vDispositivos.noPermisos"),
      });
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key')

    this.$nextTick(() => {
      this.getConfiguraciones();
    });

  },

  computed: {
    ipState() {
      const regex = /^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;
      return regex.test(this.configuraciones.ip);

    },
    puertotk108State() {
      // Verificamos primero que la propiedad exista para evitar errores de undefined
      if (!this.configuraciones?.puertotk108) {
        return false;
      }

      // Usamos String.raw para evitar el doble escape \\
      return !!this.configuraciones.puertotk108.match(String.raw`^\d{4}$`);
    },
    puertotkstarState() {
      if (!this.configuraciones?.puertotkstar) {
        return false;
      }

      return !!this.configuraciones.puertotkstar.match(String.raw`^\d{4}$`);
    },
    phoneState() {
      if (!this.configuraciones?.telArduino) {
        return false;
      }

      return !!this.configuraciones.telArduino.match(String.raw`^\d{10}$`);
    },

    countriesMap() {
      return countries.map(coun => ({
        value: coun.iso,
        text: `${coun.bandera} ${coun.paisNombre} (${coun.dialCode})`
      }))
    },

    paisSeleccionadoData() {

      return countries.find(country => country.iso === this.configuraciones.iso) || null
    }
  },
  watch: {
    paisSeleccionado(nuevoPais) {
      if (nuevoPais) {
        this.configuraciones.iso = nuevoPais.value;
        // Extraemos el nombre y dialCode buscando en el json original si es necesario
        const original = countries.find(c => c.iso === nuevoPais.value);
        if (original) {
          this.configuraciones.paisNombre = original.paisNombre;
          this.configuraciones.dialCode = original.dialCode;
        }
      }
    }
  },
  methods: {
    /**
     * Método encargado de descifrar los datos obtenidos.
     * @param {M} response valor a descifrar
     * @return Datos descifrados
     */
    async decodedData(response) {
      const data = await Crypto.desencriptar(response.data, this.key);
      return data;
    },

    /**
     * Método encargado de generar alertas genéricas
     * @param {*} icon tipo de icono a usar 'success', 'error', 'warning', etc
     * @param {*} message Mensaje a mostrar al usuario de acuerdo al estado
     */
    alertSweet(icon, message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      });

      Toast.fire({
        icon: icon,
        title: message
      });
    },

    async getConfiguraciones() {
      try {
        const response = await ConfiguracionesDataService.getAll();
        const decoded = await this.decodedData(response) || [];

        console.log("configuraciones: ", decoded);

        if (decoded.length === 0) {
          this.limpiarConfiguracionLocal();
        } else {
          const config = decoded[0];
          this.configuraciones = { ...config };

          // PRESELECCIONAR EN EL MULTISELECT
          if (config.iso) {
            this.paisSeleccionado = this.countriesMap.find(c => c.value === config.iso);
          }

          this.guardarStorageIntervloAlertaDispositivo(config.intervaloTiempoAlerta, config.intervaloTiempoDispositivo);
          this.configuracionesAct = { ...this.configuraciones };
        }
      } catch (e) {
        this.manejarErrorConfiguracion(e);
      }
    },



    limpiarConfiguracionLocal() {
      console.log("🧹 Limpiando configuración y aplicando valores por defecto");

      // Limpieza de Storage
      localStorage.removeItem('intervaloAlerta');
      localStorage.removeItem('intervaloDispositivo');

      // Valores por defecto para el objeto configuraciones
      this.configuraciones = {
        id: "",
        ip: "",
        puertotk108: "",
        puertotkstar: "",
        apn: "",
        telArduino: "",
        radio: 50,
        intervaloTiempoAlerta: 3000,
        intervaloTiempoDispositivo: 5,
        iso: "MX", // Default para tu zona
        paisNombre: "Mexico",
        dialCode: "+52"
      };

      // Preseleccionar México en el componente de países
      if (this.countriesMap) {
        this.paisSeleccionado = this.countriesMap.find(opt => opt.iso === 'MX');
      }
    },

    actualizarRegistrarConfiguracion() {
      this.configuracionesAct.id === 0 ? this.registrarCongiguracion() : this.actualizarConfiguracion();
    },

    async registrarCongiguracion() {
      if (!this.paisSeleccionado) {
        this.alertSweet('warning', 'Seleccione un país');
        return;
      }

      try {
        const response = await ConfiguracionesDataService.create({ ...this.configuraciones }, this.key)
        if (response.status === 201) {
          this.submitted = true;
          this.setDatosRegistrarBitacora({ ...this.configuraciones })
          await this.registrarConfiguracionBitacora();
          this.getConfiguraciones();

          this.alertSweet('success', this.$t("vConfiguraciones.msgRegConfig"))
        }
      } catch (error) {
        console.error("error en la funcion registrarCongiguracion: ", error)
        this.alertSweet('error', this.$t("vConfiguraciones.msgErrRegConfig"))
      }
    },


    async actualizarConfiguracion() {

      this.configuraciones.iso = this.paisSeleccionadoData.iso
      this.configuraciones.paisNombre = this.paisSeleccionadoData.paisNombre
      this.configuraciones.dialCode = this.paisSeleccionadoData.dialCode

      try {
        sessionStorage.setItem("idConfiguracion", this.configuraciones.id);

        const response = await ConfiguracionesDataService.update({ ...this.configuraciones }, this.key)

        if (response.status === 200) {
          this.submitted = true;
          this.setDatosActualizarBitacora()
          await this.registrarConfiguracionBitacora();
          await this.getConfiguraciones();
          this.configuracionesAct.id = 1;

          this.alertSweet('success', this.$t('vConfiguraciones.msgActualizarConfig'))
        }

      } catch (error) {
        console.error("Error al actualizar la configuracion: ", error)
        this.alertSweet('error', this.$t('vConfiguraciones.msgErrActualizar'))
      }
    },

    // se guarda el intervaloTiempoAlerta de actualizacion de alertas en localStorage
    guardarStorageIntervloAlertaDispositivo(intervaloTiempoAlerta, intervaloTiempoDispositivo) {
      const tiempoActualizacionAlerta = this.convertirIntervaloTiempoMilisegundos(intervaloTiempoAlerta);
      const tiempoActualizacionDispositivo = this.convertirIntervaloTiempoMilisegundos(intervaloTiempoDispositivo);

      localStorage.setItem("intervaloAlerta", tiempoActualizacionAlerta);
      localStorage.setItem("intervaloDispositivo", tiempoActualizacionDispositivo);
    },

    setDatosRegistrarBitacora(data) {
      this.accion = `Creó registro de configuraciones. 
        IP del servidor: ${data.ip}. 
        Número telefónico del arduino: ${data.telArduino}. 
        Radio para almacenar posiciones estáticas: ${data.radio}. 
        Puerto para dispositivos COBAN: ${data.puertotk108}. 
        Puerto para dispositivos TKSTAR: ${data.puertotkstar}. 
        APN: ${data.apn}. 
        Intervalo de actualización de alertas de: ${data.intervaloTiempoAlerta} ${this.tipoTiempo}.
        Intervalo de actualización de dispositivos de: ${data.intervaloTiempoDispositivo} ${this.tipoTiempo}.`;
    },

    setDatosActualizarBitacora() {
      //para registro de actualización en bitacora
      this.accion = "Actualizó el registro de configuraciones: ";
      if (this.configuracionesAct.ip !== this.configuraciones.ip) {
        this.accion += `IP del servidor, de ${this.configuracionesAct.ip} a ${this.configuraciones.ip}. `;
        this.configuracionesAct.ip = this.configuraciones.ip;
      }

      if (this.configuracionesAct.telArduino !== this.configuraciones.telArduino) {
        this.accion += `Número telefónico del arduino, de ${this.configuracionesAct.telArduino} a ${this.configuraciones.telArduino}.`;
        this.configuracionesAct.telArduino = this.configuraciones.telArduino;
      }

      if (this.configuracionesAct.radio !== this.configuraciones.radio) {
        this.accion += `Radio para almacenar posiciones estáticas, de ${this.configuracionesAct.radio} a ${this.configuraciones.radio}.`
        this.configuracionesAct.radio = this.configuraciones.radio
      }

      if (this.configuracionesAct.puertotk108 !== this.configuraciones.puertotk108) {
        this.accion += `Puerto para dispositivos COBAN, de ${this.configuracionesAct.puertotk108} a ${this.configuraciones.puertotk108}.`
        this.configuracionesAct.radio = this.configuraciones.radio
      }

      if (this.configuracionesAct.puertotkstar !== this.configuraciones.puertotkstar) {
        this.accion += `Puerto para dispositivos TKSTAR, de ${this.configuracionesAct.puertotkstar} a ${this.configuraciones.puertotkstar}.`
        this.configuracionesAct.puertotkstar = this.configuraciones.puertotkstar
      }

      if (this.configuracionesAct.apn !== this.configuraciones.apn) {
        this.accion += `APN, de ${this.configuracionesAct.apn} a ${this.configuraciones.apn}.`
        this.configuracionesAct.apn = this.configuraciones.apn
      }

      if (this.configuracionesAct.tipoTiempo !== this.configuraciones.tipoTiempo) {
        this.accion += `Tiempo, de ${this.configuracionesAct.tipoTiempo} a ${this.configuraciones.tipoTiempo}.`
        this.configuracionesAct.tipoTiempo = this.configuraciones.tipoTiempo
      }

      if (this.configuracionesAct.intervaloTiempoAlerta !== this.configuraciones.intervaloTiempoAlerta) {
        this.accion += `Intervalo actualización alertas, de ${this.configuracionesAct.intervaloTiempoAlerta} a ${this.configuraciones.intervaloTiempoAlerta}.`
        this.configuracionesAct.intervaloTiempoAlerta = this.configuraciones.intervaloTiempoAlerta
      }

      if (this.configuracionesAct.intervaloTiempoDispositivo !== this.configuraciones.intervaloTiempoDispositivo) {
        this.accion += `Intervalo actualización dispositivos, de ${this.configuracionesAct.intervaloTiempoDispositivo} a ${this.configuraciones.intervaloTiempoDispositivo}.`
        this.configuracionesAct.intervaloTiempoDispositivo = this.configuraciones.intervaloTiempoDispositivo
      }
    },

    // convierte el tiempo a milisegundos
    convertirIntervaloTiempoMilisegundos(intervaloTiempo) {
      return intervaloTiempo * 1000
    },

    validaciones() {
      return !(
        this.ipState &&
        this.puertotk108State &&
        this.puertotkstarState &&
        this.phoneState
      );
    },

    async registrarConfiguracionBitacora() {
      const data = {
        usuario: this.usuarioLogueado || JSON.parse(sessionStorage.getItem("usuarioLogueado")),
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "configuracion",
      };

      await AccionesDataService.create(data, this.key);
    },
  },
};
</script>

<style>
.alineacion-text-inicio {
  text-align: start;
}

.tamanioFijo {
  height: 100%;
}

@media (max-width: 599px) {
  .margin-top-div {
    margin-top: -12px;
  }
}

@media (min-width: 601px) {
  .flex-md {
    margin-top: -12px;
  }
}

@media (min-width: 769px) {
  .ancho-boton {
    width: 300px !important;
  }

  .flex-md {
    display: flex;
    justify-content: center;
  }
}
</style>